"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "udine": {
    "47ee5af7": [{
      "hkey": "e447e1ca",
      "slug": "baldasseria-viale-palmanova",
      "name": "Baldasseria-Viale Palmanova",
      "primary": true,
      "skipSearch": false
    }],
    "baldasseria-bassa": [{
      "hkey": "e447e1ca",
      "slug": "baldasseria-viale-palmanova",
      "name": "Baldasseria-Viale Palmanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cb26eaec": [{
      "hkey": "ce4151ea",
      "slug": "beivars-godia",
      "name": "Beivars-Godia",
      "primary": true,
      "skipSearch": false
    }],
    "beivars": [{
      "hkey": "ce4151ea",
      "slug": "beivars-godia",
      "name": "Beivars-Godia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f78e833e": [{
      "hkey": "1922611b",
      "slug": "cormor-viale-venezia",
      "name": "Cormor-Viale Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "cormor-alto": [{
      "hkey": "1922611b",
      "slug": "cormor-viale-venezia",
      "name": "Cormor-Viale Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f52f9854": [{
      "hkey": "1922611b",
      "slug": "cormor-viale-venezia",
      "name": "Cormor-Viale Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "cormor-basso": [{
      "hkey": "1922611b",
      "slug": "cormor-viale-venezia",
      "name": "Cormor-Viale Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "udine"
    }],
    "38ae4450": [{
      "hkey": "896a96ec",
      "slug": "cussignacco-paparotti",
      "name": "Cussignacco-Paparotti",
      "primary": true,
      "skipSearch": false
    }],
    "cussignacco": [{
      "hkey": "896a96ec",
      "slug": "cussignacco-paparotti",
      "name": "Cussignacco-Paparotti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5db3ccdc": [{
      "hkey": "ce4151ea",
      "slug": "beivars-godia",
      "name": "Beivars-Godia",
      "primary": true,
      "skipSearch": false
    }],
    "godia": [{
      "hkey": "ce4151ea",
      "slug": "beivars-godia",
      "name": "Beivars-Godia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "udine"
    }],
    "67fd5b5c": [{
      "hkey": "7922de07",
      "slug": "laipacco-via-buttrio",
      "name": "Laipacco-Via Buttrio",
      "primary": true,
      "skipSearch": false
    }],
    "laipacco": [{
      "hkey": "7922de07",
      "slug": "laipacco-via-buttrio",
      "name": "Laipacco-Via Buttrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d1d0fb88": [{
      "hkey": "6cd4c67c",
      "slug": "udine",
      "name": "Udine",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "6cd4c67c",
      "slug": "udine",
      "name": "Udine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e921dde0": [{
      "hkey": "1b4f80fe",
      "slug": "rizzi-stadio",
      "name": "Rizzi-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "rizzi": [{
      "hkey": "1b4f80fe",
      "slug": "rizzi-stadio",
      "name": "Rizzi-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "201491a2": [{
      "hkey": "ffd3dd44",
      "slug": "san-gottardo-via-del-bon",
      "name": "San Gottardo-Via del Bon",
      "primary": true,
      "skipSearch": false
    }],
    "san-gottardo": [{
      "hkey": "ffd3dd44",
      "slug": "san-gottardo-via-del-bon",
      "name": "San Gottardo-Via del Bon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2daba3fa": [{
      "hkey": "467592f9",
      "slug": "borgo-aquilea-teatro-viale-ungheria",
      "name": "Borgo Aquilea-Teatro-Viale Ungheria",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "7e5a6703",
      "slug": "borgo-gemona-viale-diaz",
      "name": "Borgo Gemona-Viale Diaz",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "8cb9f700",
      "slug": "grazzano-poscolle-villalta",
      "name": "Grazzano-Poscolle-Villalta",
      "primary": false,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "467592f9",
      "slug": "borgo-aquilea-teatro-viale-ungheria",
      "name": "Borgo Aquilea-Teatro-Viale Ungheria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "udine"
    }]
  }
};
exports["default"] = _default;